import React, { useMemo, useState } from 'react'

import { graphql } from 'gatsby'
import 'keen-slider/keen-slider.min.css'
import { PrismicRichText } from '@prismicio/react'

import Img from '../components/Img'
import Input from '../components/Input'
import Button from '../components/Button'

import { useMatchMedia } from '../hooks/useMatchMedia'

const MainSectionWithForm = ({ slice }) => {
  const { primary } = slice

  const { isMatching, calculated } = useMatchMedia('(max-width:768px)', true)

  const [value, setValue] = useState('')
  const [success, setSuccess] = useState(false)

  const submitForm = () => {
    console.log('submit', value)
    setSuccess(true)
    setTimeout(() => {
      setSuccess(false)
    }, 3000)
  }

  const RenderImage = useMemo(
    () => (
      <Img
        image={primary?.image?.gatsbyImageData}
        alt={primary?.image?.alt}
        className="background"
        objectFit="contain"
      />
    ),
    [primary?.image?.alt, primary?.image?.gatsbyImageData],
  )
  return (
    <section
      className={`main-section-with-form ${primary?.page} ${
        primary?.theme && `main-section-with-form--${primary?.theme}`
      }`}
    >
      {primary?.background_image_one?.gatsbyImageData && (
        <Img
          image={primary.background_image_one.gatsbyImageData}
          alt={primary?.background_image_one?.alt}
          className="background-image background-image-one"
        />
      )}
      <div className="container">
        <div className="main-section-with-form-info">
          <PrismicRichText field={primary?.title?.richText} />
          <p className="p p-18">{primary?.description?.text}</p>
          {isMatching && calculated && RenderImage}
          <form className="form">
            {success ? (
              <p className="p-18">{primary.success_message.text}</p>
            ) : (
              <>
                <Input
                  type={primary?.input_type}
                  placeholder={primary?.input_placeholder.text}
                  value={value}
                  onChange={setValue}
                  required
                />
                <Button data={primary} callback={submitForm} />
              </>
            )}
          </form>
          <div className="info-text">
            <PrismicRichText field={primary?.input_text_info?.richText} />
          </div>
        </div>
        {!isMatching && RenderImage}
      </div>
      <div className="background-shadow" />
      {primary?.background_image_one?.gatsbyImageData && (
        <Img
          image={primary.background_image_one.gatsbyImageData}
          alt={primary?.background_image_one?.alt}
          className="background-image background-image-two"
        />
      )}
    </section>
  )
}

export default MainSectionWithForm

export const query = graphql`
  fragment TechnologyPageTemplateDataBodyMainSectionWithInput on PrismicTechnologyPageTemplateDataBodyMainSectionWithInput {
    id
    primary {
      title {
        richText
      }
      theme
      success_message {
        text
      }
      page
      input_type
      input_placeholder {
        text
      }
      image {
        gatsbyImageData
        alt
      }
      input_text_info {
        richText
      }
      description {
        text
      }
      button_title {
        text
      }
      button_theme
      background_image_two {
        gatsbyImageData
        alt
      }
      background_image_one {
        alt
        gatsbyImageData
      }
    }
  }
`
